import { SettlementReqStatus } from "../../../Helpers/Enums/ApplicationStatus";
import { SettlementDashboardModules } from "../../../Helpers/Enums/SettlementDashboardModules";
import { RoleEnum } from "../../../Helpers/Enums/RoleEnum";
import { SettlementRequestEnums } from "../Enums/SettlementRequestEnums";

export const getStatusIds = (
  module: SettlementRequestEnums,
  loggedInAs: RoleEnum
) => {
  let statusIds = [];
  
  switch (module) {
    case SettlementRequestEnums.All:
      switch (loggedInAs) {
        case RoleEnum.InternalTeam:
          statusIds = [
            SettlementReqStatus.Settlement_Approval_Pending,
            SettlementReqStatus.Settlement_Approved,
            SettlementReqStatus.Settlement_Approved2,
            SettlementReqStatus.Settlement_Rejected,
            SettlementReqStatus.Settlement_Data_Pending,
            SettlementReqStatus.FinalSettlementApprovalPending,
            
          ];
          break;
        case RoleEnum.Member:
          statusIds = [
            SettlementReqStatus.Settlement_Approval_Pending,
            SettlementReqStatus.Settlement_Approved,
            SettlementReqStatus.Settlement_Approved2,
            SettlementReqStatus.Settlement_Rejected,
            SettlementReqStatus.Settlement_Data_Pending,
            SettlementReqStatus.FinalSettlementApprovalPending,
          ];
          break;
        case RoleEnum.Admin:
          break;
        case RoleEnum.EnrollmentCommittee:
          break;
        case RoleEnum.LoanCommittee:
          break;
        case RoleEnum.HRHOD:
          break;
      }
      break;
    case SettlementRequestEnums.Pending:
      switch (loggedInAs) {
        case RoleEnum.InternalTeam:
          statusIds = [
            SettlementReqStatus.Settlement_Approval_Pending,
            SettlementReqStatus.Settlement_Approved,
            // SettlementReqStatus.Settlement_Approved2,
          ];
          break;
          case RoleEnum.Member:
            statusIds = [
              SettlementReqStatus.Settlement_Approval_Pending,
              SettlementReqStatus.Settlement_Approved,
              // SettlementReqStatus.Settlement_Approved2,
              SettlementReqStatus.Settlement_Rejected,
              SettlementReqStatus.Settlement_Data_Pending,
          ];
          break;
        case RoleEnum.Admin:
          break;
        case RoleEnum.EnrollmentCommittee:
          break;
        case RoleEnum.LoanCommittee:
          break;
        case RoleEnum.HRHOD:
          break;
      }
      break;
  }

  return statusIds;
};

export const getActionEditSettlement = (loggedInAs: RoleEnum) => {
  let editableStatuses = [];

  switch (loggedInAs) {
    case RoleEnum.InternalTeam:
      editableStatuses = [
        ...editableStatuses,
        ...getStatusIds(SettlementRequestEnums.Pending, loggedInAs),
      ];
      break;
    case RoleEnum.Member:
      editableStatuses = [
        ...editableStatuses,
        ...getStatusIds(SettlementRequestEnums.Pending, loggedInAs),
      ];
      break;
    case RoleEnum.Admin:
      break;
    case RoleEnum.EnrollmentCommittee:
      break;
    case RoleEnum.LoanCommittee:
      break;
    case RoleEnum.HRHOD:
      break;
  }
  editableStatuses = [...new Set(editableStatuses)];
  return editableStatuses;
};
